import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import router from './router'
import store from './store'
import './assets/style/common.less'
import './styles/index.less'
import * as echarts from 'echarts'
import 'echarts-extension-amap'
import initGlobalFilters from './utils/globel-filters'
// import VueAnimateNumber from 'vue-animate-number'eslintConfig
import dataV from '@jiaminghi/data-view'

import dayjs from 'dayjs'
import './utils/rem'
var quarterOfYear = require('dayjs/plugin/quarterOfYear')
dayjs.extend(quarterOfYear)
Vue.prototype.dayjs = dayjs
// eslint-disable-next-line no-undef
Vue.prototype.$echarts = echarts
Vue.use(echarts)
Vue.use(dataV)

Vue.config.productionTip = false
Vue.use(ElementUI)

// Vue.use(VueAnimateNumber)

// initGlobalFilters
initGlobalFilters(Vue)
function noon() {}

const whiteList = ['/index', '/404', '/401', '/login'] // 不重定向白名单
router.beforeEach((to, from, next) => {
  // console.log('beforeEach', from, to)
  store.commit('globalVariable/setHistory', to.path)
  if (whiteList.includes(to.path)) {
    next()
    return null
  }
  if (!store.getters.user) {
    const params = {
      selfAreaId: store.getters.globaleSelfAreaId
    }
    // 用户数据拉取
    store.dispatch('user/getInfo', params).then(res => {
      store.commit('globalVariable/selfAddress', res.data && res.data.areaName)
      // 用户权限拉取
      store.dispatch('user/getPermission', params).then(() => noon)
      // 用户区域范围拉取
      const areaParams = {
        userAreaId: res.data.areaId,
        selfAreaId: store.getters.globaleSelfAreaId,
        areaId: store.getters.globaleSelfAreaId
      }
      store.dispatch('user/getUserArea2', areaParams).then(() => noon)
      const nationalParams = {
        selfAreaId: store.getters.globaleSelfAreaId
      }
      store.dispatch('globalVariable/getNationalArea', nationalParams).then(() => noon)
      next()
    }).catch(() => next())
  } else {
    next()
  }
})
Vue.mixin({
  data() {
    return {
      permission: true
    }
  },
  methods: {
    // val 值，key 第一级，type，
    // 一级检验：checkUserAuth(4,'id',null)
    // 二级校验：checkUserAuth(6, 'id', 'child', 'id', 28)
    // 优化结果：一级检验：checkUserAuth(4,null)
    // 优化结果：二级检验：checkUserAuth(4,28)
    checkUserAuth(val, itemVal) {
      if (itemVal === 'show') {
        return true
      }
      const key = 'id'
      const towkey = 'child'
      const threekey = 'id'
      let permission = false
      const curr = (this.user && this.user.auth) || []
      if (!curr || !curr.length) {
        return permission
      }
      if (itemVal || itemVal === 0) {
        const res = curr.find(it => it[key] === val) && curr.find(it => it[key] === val)[towkey]
          ? curr.find(it => it[key] === val)[towkey].filter(it => it[threekey] === itemVal)
          : []
        if (res.length > 0) {
          permission = true
        }
      } else {
        const res = curr.filter(it => it[key] === val)
        if (res.length > 0) {
          permission = true
        }
      }
      return permission
    }
  },
  created() {
    document.title = '共享单车管理服务平台'
  }
})
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
